var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col mx-auto"},[_c('HeaderBar',{attrs:{"auto-hidden":_vm.headerAutoHidden}}),_c('AppMain'),_c('FooterBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }